<template>
  <el-card class="box-card">
    <template #header>
      <div class="card-header">
        <el-page-header content="到期预警" @back="$router.back()" />
      </div>
    </template>
    <el-form label-width="120px" label-position="top">
      <el-form-item>
        <el-radio-group v-model="searchType" @change="onChange">
          <el-radio label="产品注册证" size="large" border>产品注册证</el-radio>
          <el-radio label="医疗器械经营许可证" size="large" border>医疗器械经营许可证</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="请输入预警天数" v-model="searchDay" style="width: 50%;min-width: 260px">
          <el-button type="primary" slot="append" @click="onSubmit">(天)到期查询</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="公司名称">
      </el-table-column>
      <el-table-column
        prop="xydm"
        label="信用代码">
      </el-table-column>
      <el-table-column
        prop="clrq"
        label="成立日期"
        :formatter="formatter">
      </el-table-column>
      <el-table-column
        prop="jzrq"
        label="进驻日期"
        :formatter="formatter">
      </el-table-column>
      <el-table-column
        prop="cType"
        label="类型">
      </el-table-column>
      <el-table-column
        prop="text"
        label="信息">
      </el-table-column>
      <el-table-column
        prop="createDate"
        label="发证日期"
        :formatter="formatter">
      </el-table-column>
      <el-table-column
        prop="validDate"
        label="有效期至">
        <template slot-scope="scope">
          <el-tag
            type="danger"
            disable-transitions>{{formatter(scope.row, scope.column)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.close&&(scope.row.close===1||scope.row.close.data[0]===1) ? 'info' : 'success'"
            disable-transitions>{{scope.row.close&&(scope.row.close===1||scope.row.close.data[0]===1)?'封存':'正常'}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="pageSize"
      :pager-count="11"
      layout="prev, pager, next"
      :total="total"
      :hide-on-single-page="true"
      @current-change="handleCurrentChange">
    </el-pagination>
  </el-card>
</template>

<script>
import util from '../plugins/util'
export default {
  data () {
    return {
      searchType: '产品注册证',
      searchDay: 180,
      pageIndex: 1,
      pageSize: 5,
      tableData: [],
      total: 0
    }
  },
  created () {
    if (!sessionStorage.getItem('jId')) {
      this.$router.push('/login').then()
    }
  },
  methods: {
    onSubmit () {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        type: this.searchType,
        day: this.searchDay
      }
      // console.log(params)
      this.$http.get(this.apiUrl + '/sys/getWarnList', { params: params })
        .then(response => {
          // console.log(response)
          if (response.status === 200) {
            let datas = response.data
            this.tableData = datas.data
            this.total = datas.total
          } else {
            this.$message.error('查询失败，请检查数据库连接')
          }
        })
    },
    onChange () {
      if (this.searchType === '产品注册证') {
        this.searchDay = 180
      } else if (this.searchType === '医疗器械经营许可证') {
        this.searchDay = 90
      }
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.pageIndex = val
      this.onSubmit()
    },
    formatter (row, column) {
      // console.log(row, column)
      const date = row[column.property]
      return date && !(date.indexOf('0000') > -1) ? util.formatDate.format(new Date(date), 'yyyy-MM-dd') : '-'
    }
  }
}
</script>

<style scoped>
.box-card {
  width: calc(100% - 4rem - 2px);
  min-height: calc(100% - 4rem - 2px);
  margin: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/warn.vue